import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { PageDetailComponent } from '@next/core-lib/components';
import { LocaleService } from '@next/core-lib/i18n';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { PrintService } from 'src/app/shared/services/print.service';

import { Cycle } from '../../models/cycle.model';
import { getSelectedCycle } from '../../store/selectors/cycle.selectors';
import { CycleNavigationComponent } from '../cycle-navigation/cycle-navigation.component';

@Component({
  selector: 'app-cycle-item',
  templateUrl: './cycle-item.component.html',
  imports: [PageDetailComponent, CycleNavigationComponent, RouterOutlet, AsyncPipe],
})
export class CycleItemComponent implements OnDestroy {
  readonly pageTitle$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  readonly subscriptions: Subscription[] = [];
  private pageTitle = '';

  constructor(
    private readonly store: Store<RootState>,
    private readonly locale: LocaleService,
    private readonly router: Router,
    printService: PrintService,
  ) {
    this.subscriptions.push(
      this.store
        .pipe(
          select(getSelectedCycle),
          map((cycle: Cycle) => {
            const title = this.locale.translate('cycle.cycle');
            const number =
              !!cycle && Object.prototype.hasOwnProperty.call(cycle, 'cycleNumber')
                ? String(cycle.cycleNumber)
                : '';
            return `${title} ${number}`;
          }),
        )
        .subscribe((title) => {
          this.pageTitle = title;
          this.pageTitle$.next(title);
        }),
    );
    this.subscriptions.push(
      printService.beforePrintCalled$.subscribe((context) => {
        this.pageTitle$.next(context.properties.title);
      }),
    );
    this.subscriptions.push(
      printService.afterPrintCalled$.subscribe((_) => {
        this.pageTitle$.next(this.pageTitle);
      }),
    );
  }

  getState = (outlet: RouterOutlet) => outlet.isActivated && outlet.activatedRoute.routeConfig.data;

  back = () => this.router.navigate(['/cycle']);

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((s) => s.unsubscribe());
    }
  }
}
